import {
  concat,
  reduce,
  curry,
  pipe,
  values,
  keys,
  juxt,
  zipObj,
  map,
  path,
  ifElse,
  always,
  find,
  isEmpty,
  identity,
  filter,
  propEq,
  findIndex,
  prop,
} from 'ramda'

export function appendString(a) {
  return x => (x && a ? concat(x, a) : null)
}

export function isFalsy(v) {
  return !v
}

export function isTruthy(v) {
  return !!v
}

export const stagger = curry((f, g, x, y) => f(x)(g(y)))

export const sumProp = field => reduce((a, n) => a + n[field], 0)

export const sumWith = f => reduce((a, n) => a + f(n), 0)

export const cReduce = curry((curriedReducer, start, arr) =>
  reduce((a, n) => curriedReducer(n)(a), start, arr),
)

export const makeObj = curry((funcObj, data) => map(f => f(data))(funcObj))

export const mapMakeObj = x => map(makeObj(x))

export const propIsTruthy = curry((p, o) => !!o[p])

export const propIsFalsy = curry((p, o) => !o[p])

export const pathMap = curry((p, f) => pipe(path(p), map(f)))

export const findOr = curry((other, f) =>
  ifElse(
    x => !!x,
    pipe(find(f), x => (x ? x : other)),
    always(other),
  ),
)

export const nonEmptyOr = curry((x, y) => ifElse(isEmpty, always(x), identity)(y))

export const filterByProp = prop => filter(propEq(prop, true))

export const findIndexByPropValue = (prop, value) => findIndex(propEq(prop, value))

export const mutate = (prop, value) => x => {
  x[prop] = value
  return x
}

export const maybeMutate = (prop, value) => x => {
  if (x) x[prop] = value
  return x
}

export const propDo = curry((propName, f) => pipe(prop(propName), f))
